import { ALLOWED_QUERY_PARAMS, CHANNEL_TYPES } from '../constants/common';
import { bidgelyStorage } from './storageHelper';
import { PREFERENCES_BASE_PATH } from '../constants/paths';

const queryString = require('query-string');

export function parseQueryParams(queryParamString){
    return (queryString.parse(queryParamString));
}

export function queryParamsToCamelCase(str) {
  return str.replace(/-([a-z])/g,  (g) => {
     return g[1].toUpperCase();
     }
  );
}

export function setRefValues(props) {
  let refVal = {
    referrer : CHANNEL_TYPES.WEB,
    ref_type : props.lastLocation.pathname
  };
  if(props.location.pathname === props.lastLocation.pathname){
    if(props.queryParams.deliveryMode) {
      refVal = {
        referrer : props.queryParams.deliveryMode,
        ref_type: props.queryParams.eventType
      }
    }
  }
  return refVal;
}

export function setAndPrepareStateParam(location, persistParams) {
  let queryParams = parseQueryParams(location.search);
  let parsedData = {};
  let key_;

    Object.keys(queryParams).map( (param) => {
    if(ALLOWED_QUERY_PARAMS.indexOf(param) >= 0){
         if(persistParams){
          bidgelyStorage.setItem(param, queryParams[param]);
         }
       key_ = queryParamsToCamelCase(param);
       parsedData[key_] = queryParams[param];
    }
  });
    return parsedData;
}

export function getCleanURL(location) {
  let queryParams = parseQueryParams(location.search);
  let params = [];
  const excludeParams = ['user-hash'];

  for (const param in queryParams) {
    if (excludeParams.indexOf(param) === -1) {
      params.push(`${param}=${queryParams[param]}`)
    }
  }

  let queryString = params.join('&');
  queryString = queryString ? `?${queryString}` : '';
  return `${location.pathname}${queryString}`;
}
